import { Button } from '@mui/material'
import { normalizedName } from '../../../components/entities/CompanyName'
import React from 'react'

export const NewIssueQuickButton = ({ company, ...buttonProps }) => {
    if (!company) return null
    return (
        <Button variant='contained' color='primary' size='small' {...buttonProps}>
            Ny emission för {normalizedName(company.name)}
        </Button>
    )
}
